import {
  //GetAllFilesModeration
  getAllFilesModeration,
  addFilesModeration,
  editFilesModeration,

} from "../../api/moderation";

export default {
  /////////////////
  // GetModerationAll
  /////////////////
  fetchModerationAllEmission({ commit }) {
    return new Promise((resolve, reject) => {
      getAllFilesModeration()
        .then(res => {
          commit("SET_MODERATATION_ALL_EMISSION", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addModerationAllEmission({ commit }, a) {
    return new Promise((resolve, reject) => {
      addFilesModeration(a)
        .then(res => {
          commit("ADD_MODERATATION_ALL_EMISSION", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editModerationAllEmission({ commit }, a) {
    return new Promise((resolve, reject) => {
      editFilesModeration(a)
        .then(res => {
          commit("EDIT_MODERATATION_ALL_EMISSION", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },



};
